var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, memo, useState } from 'react';
import { useDispatch, useStore } from 'react-redux';
import { addToCart, resetCanvasToDefaults, updateCartItem, } from '../../Actions/Rutab/DecalEditor.action';
import { exportForPrinting } from '../../Editor/CanvasHelpers';
import { useCanvasObjectCount, useCartError, useIsAddingToCart, useSignForEdit, } from '../../Editor/Hooks/useReadOnlyState';
import { handleUrlUpdate } from '../../Helpers/UrlService';
import { copyCanvasForSvgExport } from '../../Editor/ExportCanvasToSvg';
const AddToCart = ({ fabricCanvas }) => {
    const dispatch = useDispatch();
    const store = useStore();
    const [svg, setSvg] = useState(null);
    const canvasObjectCount = useCanvasObjectCount();
    const isAddingToCart = useIsAddingToCart();
    const signForEdit = useSignForEdit();
    const cartError = useCartError();
    const handleAddToCart = () => __awaiter(void 0, void 0, void 0, function* () {
        const state = store.getState();
        const cartQuantity = state.decalEditorAPI.cartQuantity;
        const canvasSize = state.decalEditor.canvasSize;
        const canvasType = state.decalEditor.canvasType;
        const selectedForm = state.decalEditor.selectedForm;
        const holePlacement = state.decalEditor.holePlacement;
        const uploadedImages = state.decalEditorAPI.uploadedImages;
        const productTemplate = state.decalEditorAPI.productTemplate;
        const productTemplateModified = state.decalEditorAPI.productTemplateModified;
        const exportObject = exportForPrinting(fabricCanvas, canvasSize, canvasType, selectedForm, holePlacement, uploadedImages);
        exportObject.rowSystemId = signForEdit === null || signForEdit === void 0 ? void 0 : signForEdit.rowSystemId;
        const svg = yield copyCanvasForSvgExport(fabricCanvas, canvasSize, true);
        exportObject.exportedSvg = svg;
        if (productTemplate && !productTemplateModified) {
            exportObject.productTemplateId = productTemplate.variantId;
        }
        if (exportObject.rowSystemId) {
            dispatch(updateCartItem(exportObject, cartQuantity));
            handleUrlUpdate();
        }
        else {
            dispatch(addToCart(exportObject, cartQuantity));
            handleUrlUpdate();
        }
    });
    const showPreview = () => __awaiter(void 0, void 0, void 0, function* () {
        const state = store.getState();
        const canvasSize = state.decalEditor.canvasSize;
        const svg = yield copyCanvasForSvgExport(fabricCanvas, canvasSize, false);
        setSvg(svg);
    });
    const handleCancelEdit = () => {
        dispatch(resetCanvasToDefaults());
        handleUrlUpdate();
    };
    return (_jsxs(_Fragment, { children: [svg && (_jsx("div", { className: "modal-overlay", onClick: () => setSvg(null), style: {
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 1001,
                }, children: _jsxs("div", { className: "modal-content", onClick: (e) => e.stopPropagation(), style: {
                        backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        width: '90vw',
                        height: '90vh',
                        display: 'flex',
                        flexDirection: 'column',
                        boxSizing: 'border-box'
                    }, children: [_jsx("div", { style: { textAlign: 'right', marginBottom: '10px' }, children: _jsx("button", { onClick: () => setSvg(null), style: {
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '20px',
                                    cursor: 'pointer',
                                }, children: "\u00D7" }) }), _jsx("div", { style: {
                                flex: 1,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                position: 'relative',
                                height: '100%',
                                width: '100%'
                            }, children: _jsx("div", { style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    right: 0,
                                    bottom: 0,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }, dangerouslySetInnerHTML: {
                                    __html: svg ? svg.replace(/<svg /, '<svg width="100%" height="100%" preserveAspectRatio="xMidYMid meet" ') : ''
                                } }) })] }) })), _jsxs("div", { className: "button-container", children: [_jsx("div", { children: _jsxs("svg", { onClick: showPreview, xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", className: "pointer", style: { marginTop: '5px', marginRight: '15px' }, children: [_jsx("path", { d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" }), _jsx("circle", { cx: "12", cy: "12", r: "3" })] }) }), _jsx("button", { disabled: canvasObjectCount <= 0 || isAddingToCart, className: "add-to-cart-btn", onClick: handleAddToCart, children: isAddingToCart
                            ? 'Lägger till...'
                            : signForEdit && canvasObjectCount > 0
                                ? 'Spara skylt'
                                : canvasObjectCount > 0
                                    ? 'Lägg i kundvagn'
                                    : 'Skylten är tom' }), signForEdit && (_jsx(Fragment, { children: _jsx("button", { className: "cancel-edit-btn pointer", onClick: handleCancelEdit, children: "Avbryt" }) })), cartError && (_jsx("svg", { className: "decal-cart-error pointer", viewBox: "0 0 24 24", fill: "currentColor", width: "32", height: "32", children: _jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-1-13h2v6h-2zm0 8h2v2h-2z" }) }))] })] }));
};
export default memo(AddToCart);
